import React from "react";
import PropTypes from "prop-types";

import Dialog, { DialogTitle, DialogContent } from "components/common/Dialog";
import { getCountryFlag } from "components/Screens/CommonUtils";
import CustomTooltip from "components/common/Tooltip";

import GoogleCalendarIcon from "assets/images/google_calendar.svg";
import OutlookCalendarIcon from "assets/images/outlook_calendar.svg";

import "./AddToCalendarDialog.scss";

function AddToCalendarDialog({ open, onClose, calendarData }) {
  const handleCalendarClick = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      width="498px"
      title={
        <DialogTitle
          title={
            <div className="calendar-dialog-header">
              <div className="flex flex-col gap-025">
                <div className="heading-h2-semibold color-text-heading-primary">
                  Add public holidays to your calendar
                </div>
                <div className="para-body-m-regular color-text-body-primary">
                  The public holidays will appear on your calendar and stay up to date. Your calendar won’t be shared
                  with us.
                </div>
              </div>
            </div>
          }
        />
      }
      content={
        <DialogContent>
          <div className="calendar-dialog-content">
            {calendarData.map((item) => (
              <div key={item.country} className="calendar-country-row">
                <div className="calendar-country-info">
                  <div className="country-flag">{getCountryFlag(item.country, 24, 24)}</div>
                  <span className="heading-h5-medium color-text-body-secondary">{item.country} public holidays</span>
                </div>
                <div className="calendar-icons">
                  {item.calendar?.google && (
                    <CustomTooltip content="Add to Google Calendar" direction="top">
                      <button
                        type="button"
                        className="calendar-icon-button"
                        onClick={() => handleCalendarClick(item.calendar.google)}
                        aria-label="Add to Google Calendar"
                      >
                        <img src={GoogleCalendarIcon} alt="Google Calendar" className="calendar-icon" />
                      </button>
                    </CustomTooltip>
                  )}
                  {item.calendar?.outlook && (
                    <CustomTooltip content="Add to Outlook Calendar" direction="top">
                      <button
                        type="button"
                        className="calendar-icon-button"
                        onClick={() => handleCalendarClick(item.calendar.outlook)}
                        aria-label="Add to Outlook Calendar"
                      >
                        <img src={OutlookCalendarIcon} alt="Outlook Calendar" className="calendar-icon" />
                      </button>
                    </CustomTooltip>
                  )}
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
      }
    />
  );
}

AddToCalendarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  calendarData: PropTypes.arrayOf(
    PropTypes.shape({
      country: PropTypes.string.isRequired,
      calendar: PropTypes.shape({
        google: PropTypes.string,
        outlook: PropTypes.string,
      }).isRequired,
    })
  ),
};

AddToCalendarDialog.defaultProps = {
  calendarData: [],
};

export default AddToCalendarDialog;
